import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { get, save } from "../requests/doctor";
import { createSignal, onMount } from "solid-js";
import { useNavigate } from "@solidjs/router";

export default function useDoctorForm() {

  const navigate = useNavigate();

  const [loading, setLoading] = createSignal(false);
  const [photo, setPhoto] = createSignal(null);
  const [key, setKey] = createSignal(null);
  const [form, setForm] = createStore({
    email: "",
    username: "",
    password: "",
    phone: "",
    name: "",
    nic: "",
    specialization: "",
    qualifications: "",
    photoURL: "/assets/images/user.svg",
  });

  const fetchInfo = async (pid) => {
    setLoading(true);
    setKey(pid);
    try {
      const data = await get(key());
      setForm('email', data.entity.email);
      setForm('username', data.entity.username);
      setForm('phone', data.entity.phone);
      setForm('password', "XXXXXX");
      setForm('name', data.entity.name);
      setForm('nic', data.entity.nic);
      setForm('specialization', data.entity.specialization);
      setForm('qualifications', data.entity.qualifications);
      setForm('photoURL', data.entity.photoURL);
    } catch (error) {
      throw error;
    }  finally {
      setLoading(false);
    }
  }

  const { successToast, errorToast } = useApplication();

  const handleInput = (ev) => {
    setForm([ev.currentTarget.name], ev.currentTarget.value);
  };

  const handleChange = (name, value) => {
    setForm([name], value);
  };

  const handlePhotoChange = (p) => {
    setPhoto(p);
  }

  const handleSave = async (ev) => {
    ev.preventDefault();
    setLoading(true);
    try {

      const formData = new FormData();
      Object.keys(form).forEach(key => formData.append(key, form[key]));
      formData.append('photo', photo());

      if (key() !== null) {
        formData.append('id', key());
      }

      const data = await save(formData);

      successToast(data.message);
      navigate("/doctors");
    } catch (error) {
      errorToast(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    form,
    fetchInfo,
    handleSave,
    handleInput,
    handleChange,
    handlePhotoChange,
  };
}
